<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Received Dates</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>

  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Form 8 Preliminary Received:

    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'formReceivedDate'" (dateUpdated)="onDateUpdated($event, 'formReceivedDate')" [initialDate]="formReceivedDate" [disabled]="form?.get('formReceivedDate')?.disabled"></common-date-picker>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Cement Ticket Received:

    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'cementTickReceivedDate'" (dateUpdated)="onDateUpdated($event, 'cementTickReceivedDate')" [initialDate]="cementTickReceivedDate" [disabled]="form?.get('cementTickReceivedDate')?.disabled"></common-date-picker>

    </div>
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Cement Job Log Received:

    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'cementLogReceivedDate'" (dateUpdated)="onDateUpdated($event, 'cementLogReceivedDate')" [initialDate]="cementLogReceivedDate" [disabled]="form?.get('cementLogReceivedDate')?.disabled"></common-date-picker>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Safety Data Sheet Received:

    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'safetySheetReceivedDate'" (dateUpdated)="onDateUpdated($event, 'safetySheetReceivedDate')" [initialDate]="safetySheetReceivedDate" [disabled]="form?.get('safetySheetReceivedDate')?.disabled"></common-date-picker>

    </div>


    @if (reportType?.typeId == 'F8F') {
      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Date P-R Graph Received:
      </div>
      <div class="cell small-2 large-2 medium-2">
        <common-date-picker [id]="'prGraphReceivedDate'" (dateUpdated)="onDateUpdated($event, 'prGraphReceivedDate')" [initialDate]="prGraphReceivedDate" [disabled]="form?.get('prGraphReceivedDate')?.disabled"></common-date-picker>
      </div>
      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Date Stimulation Invoice Received:
      </div>
      <div class="cell small-2 large-2 medium-2">
        <common-date-picker [id]="'stimInvoiceDateReceived'" (dateUpdated)="onDateUpdated($event, 'stimInvoiceDateReceived')" [initialDate]="stimInvoiceDateReceived" [disabled]="form?.get('stimInvoiceDateReceived')?.disabled"></common-date-picker>
      </div>
      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Date Stimulation Record Received:
      </div>
      <div class="cell small-2 large-2 medium-2">
        <common-date-picker [id]="'stimRecordReceivedDate'" (dateUpdated)="onDateUpdated($event, 'stimRecordReceivedDate')" [initialDate]="stimRecordReceivedDate" [disabled]="form?.get('stimRecordReceivedDate')?.disabled"></common-date-picker>
      </div>
      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Date Stimulation Log Received:
      </div>
      <div class="cell small-2 large-2 medium-2">
        <common-date-picker [id]="'stimLogReceivedDate'" (dateUpdated)="onDateUpdated($event, 'stimLogReceivedDate')" [initialDate]="stimLogReceivedDate" [disabled]="form?.get('stimLogReceivedDate')?.disabled"></common-date-picker>
      </div>
    }

  </div>
</ng-container>